import PanelActionFooter from 'pages/MaintenancePage/components/PanelActionFooter';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { CANCEL_BUTTON_TEST_ID, SAVE_BUTTON_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

// Pure config over the shared PanelActionFooter — supplies the Log Service
// translation keys and test ids.
const LogServiceFooter: FunctionComponent<Props> = ({
    className = '',
    isSaveDisabled,
    onCancel,
    onSave,
    testId = TEST_ID
}) => {
    const t = useTranslation();

    return (
        <PanelActionFooter
            cancelTestId={CANCEL_BUTTON_TEST_ID}
            cancelText={t.LOG_SERVICE_CANCEL}
            className={className}
            isPrimaryDisabled={isSaveDisabled}
            onCancel={onCancel}
            onPrimary={onSave}
            primaryTestId={SAVE_BUTTON_TEST_ID}
            primaryText={t.LOG_SERVICE_SAVE}
            testId={testId}
        />
    );
};

export default LogServiceFooter;
